module.exports = __webpack_public_path__ + "static/media/hydroponics_systems_growslab.c4d6902b.webp";